var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFolderGrey1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-folder-grey-1",
    transform: "translate(-6.1 -5.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_549_2_",
    d: "M221.7,177.7l39.5,23.9a32.478,32.478,0,0,0,16.9,4.8h83.1a7.511,7.511,0,0,1,7.5,7.5V326.6a7.49,7.49,0,0,1-7.5,7.5H150.9a7.555,7.555,0,0,1-7.5-7.5V185.2a7.555,7.555,0,0,1,7.5-7.5h70.8m-70.8-23.6a31.112,31.112,0,0,0-31.1,31h0V326.4a31.069,31.069,0,0,0,31.1,31.1H361.1a31.027,31.027,0,0,0,31-31h0V213.9a31.112,31.112,0,0,0-31-31.1H278a8.447,8.447,0,0,1-4.6-1.3l-43.2-26.1a9.4,9.4,0,0,0-4.6-1.3H150.9Z",
    fill: "#7c7c7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M256.1,5.8c-138.1,0-250,111.9-250,250s111.9,250,250,250,250-111.9,250-250S394.1,5.8,256.1,5.8Zm0,486.5c-130.6,0-236.5-105.9-236.5-236.5S125.4,19.4,256.1,19.4,492.6,125.3,492.6,255.9,386.7,492.3,256.1,492.3Z",
    fill: "#7c7c7c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFolderGrey1);
export default __webpack_public_path__ + "static/media/icon-folder-grey-1.6232a87ce3ca784b599317ae5fa60c5e.svg";
export { ForwardRef as ReactComponent };